import { SearchType } from '@/types/search/SearchType.type'
import { createSearchList } from '@/types/search/SearchList.type'

export default {
    searchText: '',
    activeTab: 'all',
    lists: {
        member: createSearchList(SearchType.MEMBER, 6, '/members/all', '42px'),
        event: createSearchList(SearchType.EVENT, 3, '/events', '140px'),
        replay: createSearchList(SearchType.REPLAY, 3, '/events/live-and-replay', '236px'),
        benefit: createSearchList(SearchType.BENEFIT, 3, '/benefits', '162px'),
        article: createSearchList(SearchType.ARTICLE, 3, '/articles', '162px'),
    },
    history: {
        loading: false,
        loaded: false,
        results: [],
    },
}
